import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    return localStorage.getItem("lp_lang") || "de";
  });

  useEffect(() => {
    localStorage.setItem("lp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
